import { pathOr } from 'ramda'
import lang from '../lang'

const t = message => pathOr(message, ['ru', message], lang)

export default t
